// import MessageWrapper from '@/util/messageWrapper'
import Vue from 'vue'
import {
  Autocomplete,
  Button,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Message,
  MessageBox,
  Option,
  Pagination,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Scrollbar,
  Select,
  Slider,
  Switch,
  Table,
  TableColumn,
  Tag,
  Tabs,
  TabPane,
  Tooltip,
  Upload,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Alert,
  InfiniteScroll,
  Carousel,
  CarouselItem,
  Popconfirm,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Breadcrumb,
  BreadcrumbItem,
  DatePicker,
  Drawer,
  Notification,
  Tree,
  Icon,
  Image,
  Skeleton,
  SkeletonItem,
  Divider,
  Container,
  ButtonGroup,
  Empty,
  Steps,
  Step,
  Link,
  ColorPicker,
} from '@esign/esign-design-web'

import { isVNode } from '@esign/esign-design-web/src/utils/vdom'
import { isObject } from '@esign/esign-design-web/src/utils/types'
import CollapseTransition from '@esign/esign-design-web/lib/transitions/collapse-transition'
import Clickoutside from '@esign/esign-design-web/lib/utils/clickoutside'

import { initCssVars } from '@esign/esign-design-web/lib/theme'
import { Button as EdmButton } from '@esign/esign-design-mobile'
initCssVars()

const edw = {
  Autocomplete,
  Button,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Message,
  MessageBox,
  Option,
  Pagination,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Scrollbar,
  Select,
  Slider,
  Switch,
  Table,
  TableColumn,
  Tag,
  Tabs,
  TabPane,
  Tooltip,
  Upload,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Alert,
  InfiniteScroll,
  Carousel,
  CarouselItem,
  Popconfirm,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Breadcrumb,
  BreadcrumbItem,
  DatePicker,
  Drawer,
  Notification,
  Tree,
  Icon,
  Image,
  Skeleton,
  SkeletonItem,
  Divider,
  Container,
  ButtonGroup,
  Empty,
  Steps,
  Step,
  Link,
  ColorPicker,
}

const edm = {
  Button: EdmButton,
}

export default function edwRegister() {
  const { Loading, MessageBox, Message, Notification } = edw
  const blackList = ['Loading', 'Message', 'MessageBox', 'Notification']
  Vue.component(CollapseTransition.name, CollapseTransition)

  /**
   * edw
   */
  Object.keys(edw).forEach(key => {
    if (!blackList.includes(key)) {
      Vue.component(edw[key].name, edw[key])
    }
  })
  Object.keys(edm).forEach(key => {
    Vue.component(edm[key].name, edm[key])
  })
  Vue.prototype.$loading = Loading.service
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$prompt = MessageBox.prompt
  Vue.prototype.$message = Message

  // Vue.prototype.$message = MessageWrapper // 确认原项目中代码情况是否需要改成MessageWrapper，需要在头部引入import MessageWrapper from '@/util/messageWrapper'
  Vue.prototype.$notify = Notification
  Vue.prototype.$isVNode = isVNode
  Vue.prototype.$isObject = isObject
  Vue.prototype.$Clickoutside = Clickoutside
  Vue.prototype.$DatePicker = DatePicker // standing-book-front中需要
  Vue.use(Loading.directive)
}
